import React, { useEffect, useState } from "react";

import Button from '../components/Button';
import Images from '../libs/images.js'
import { LangText } from "../zustand/dict.js";
import { useNavigate } from "react-router-dom";

export default function ErrorPage() {
    const navigate = useNavigate();

    const btnFunc = () => {
        navigate("/");
    }
    
    return (
        <>
            <div className="content">
                <div className="error_box margint24">

                    <div className="text_info ">
                        <img style={{ width: 50, height: 50 }} src={Images.icn_alert}></img>
                        <p style={{ textAlign: "center" }} className="title1">페이지를 찾을 수 없습니다.</p>
                        <p style={{ textAlign: "center" }} className="title2">페이지의 주소가 올바르지 않거나 예기치 못한 에러가 발생했습니다.</p>
                    </div>

                    <div>
                        <Button type={5} title={"메인으로"} onClick={btnFunc} />
                    </div>
                </div>
            </div>
        </>
    );
}
